import { gql } from '@apollo/client';
import { FeatureFlag } from './models/feature-flags';

export interface FeatureFlagsQueryResult {
  viewer: {
    featureFlags: { [featureFlag in FeatureFlag]: boolean };
  };
}

export const GET_FEATURE_FLAGS_QUERY = gql`
  query getFeatureFlags {
    viewer {
      featureFlags {
        showAddToSlack
        showReportLanguage
        showSocialAlerts
        showSocialBrief
        reportStoryClickShowStoryReader
        newReportShowPreviewScreen
      }
    }
  }
`;
